import { PlusIcon, QuestionMarkCircleIcon } from "@heroicons/react/outline";
import { SparklesIcon } from "@heroicons/react/solid";
import { LoadingModal } from "Component/LoadingModal";
import { CustomPopover } from "Component/Popover";
import Spinner from "Component/Spinner";
import { fetchApi } from "Config/fetchApi";
import { EncryptStorage } from "encrypt-storage";
import { handleError, handleSuccess } from "Helper";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function CreateIntents() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const navData = state;
  const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);
  const userInfo = encryptStorage.getItem("___info");
  const [isLoading, setIsLoading] = useState(false);
  const [generating, setGenerating] = useState(null);

  const [intentName, setIntentName] = useState("");
  const [contextIntent, setContextIntent] = useState([]);
  const [phraseIntent, setPhraseIntent] = useState([]);
  const [responseIntent, setResponseIntent] = useState([]);

  const MultiSelectHandler = (e, state, setter) => {
    const handleCreate = (inputValue) => {
      const newOption = { value: inputValue, label: inputValue };
      setter([...state, newOption]);
    };

    if (e.key === ";" && e.target.value.trim() !== "") {
      handleCreate(e.target.value.trim());
      e.target.value = "";
      e.preventDefault();
    } else if (
      e.key === "Backspace" &&
      e.target.value.trim() === "" &&
      state.length > 0
    ) {
      setter((prevItems) => prevItems.slice(0, -1)); // Menghapus elemen terakhir
    }
  };

  const generateAIValue = async (endpoint, setter) => {
    console.log(endpoint, setter);
    let payload = { intent_name: intentName };

    const createArray = (value) => {
      return value.map((el) => el.value);
    };

    if (endpoint === "context") {
      payload = { ...payload, context: createArray(contextIntent) };
    } else if (endpoint === "phrase") {
      payload = {
        ...payload,
        context: createArray(contextIntent),
        phrase: createArray(phraseIntent),
      };
    } else if (endpoint === "response") {
      payload = {
        ...payload,
        context: createArray(contextIntent),
        phrase: createArray(phraseIntent),
        response: createArray(responseIntent),
      };
    } else {
      return;
    }

    try {
      setGenerating(endpoint);
      const response = await fetchApi().post(`/generate-${endpoint}`, payload);
      console.log(response);
      const result = response?.data?.data || [];
      const normalizedResult = result.map((el) => ({ value: el, label: el }));
      setter((prev) => [...prev, ...normalizedResult]);
    } catch (err) {
      handleError(err);
    } finally {
      setGenerating(null);
    }
  };

  const handleSubmit = async () => {
    const payload = {
      intent_name: intentName,
      context_intent: contextIntent.map((el) => el.value),
      phrase_intent: phraseIntent.map((el) => el.value),
      response_intent: responseIntent.map((el) => el.value),
    };

    try {
      setIsLoading(true);
      let response;
      if (navData) {
        response = await fetchApi().post(
          `/intent/update/${navData?.id}`,
          payload
        );
      } else {
        response = await fetchApi().post("/intent/create", payload);
      }

      handleSuccess(response?.data?.message);
      navigate(-1);
    } catch (e) {
      console.log(e);
      handleError(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (navData) {
      setIntentName(navData.intentName);
      const contextArray = navData.context.map((val) => ({
        value: val,
        label: val,
      }));
      setContextIntent(contextArray);
      const phraseArray = navData.phrase.map((val) => ({
        value: val,
        label: val,
      }));
      setPhraseIntent(phraseArray);
      const responseArray = navData.response.map((val) => ({
        value: val,
        label: val,
      }));
      setResponseIntent(responseArray);
    }
  }, [navData]);

  return (
    <div>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        <div className="rounded-2xl border-solid border-gray-300 border shadow-xl bg-white p-6">
          <div className="flex flex-col md:flex-row gap-4 md:gap-0 justify-between items-center px-5 mt-5 w-full">
            <p className="text-3xl text-start w-full font-bold">
              {navData ? "Edit" : "Create"} Intent
            </p>
            <hr className="border border-neutral-300 w-full md:hidden" />
            <button
              type="submit"
              disabled={
                intentName.trim() !== "" &&
                contextIntent.length > 0 &&
                phraseIntent.length > 0 &&
                responseIntent.length > 0
                  ? false
                  : true
              }
              className={`${intentName.trim() !== "" && contextIntent.length > 0 && phraseIntent.length > 0 && responseIntent.length > 0 ? "btn-color-talangmas hover:bg-opacity-50" : "disabled bg-gray-300"} h-11 whitespace-nowrap flex self-end md:self-auto w-auto justify-center items-center rounded-xl px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2`}
            >
              <PlusIcon
                className="text-white mr-3 shrink-0 h-6 w-6"
                aria-hidden="true"
              />
              {navData ? "Edit" : "Create"} Intent
            </button>
          </div>

          {/* Field Kolom */}
          <div className="flex justify-between items-center py-2 px-5 w-full">
            <div className="w-full">
              <label
                htmlFor="intent_name"
                className="flex text-sm font-medium leading-6 whitespace-nowrap"
              >
                Intent Name
                <p className="ml-1 text-red-700">*</p>
              </label>
              <div className="mt-2">
                <input
                  id="intent_name"
                  name="intent_name"
                  type="text"
                  disabled={isLoading}
                  value={intentName}
                  placeholder="Please input Intent name..."
                  onChange={(e) => setIntentName(e.target.value)}
                  required
                  className="capitalize h-11 block px-2 w-full rounded-md border-0 py-1.5 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 placeholder:italic focus:ring-2 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
          </div>

          {intentName.trim() !== "" ? (
            <div>
              {/* Field Kolom */}
              <div className="flex flex-col md:flex-row justify-between items-center py-2 px-5 w-full">
                <div className="flex justify-between items-center w-full ">
                  <div className="w-full">
                    <label
                      htmlFor="context"
                      className="flex gap-1 text-sm font-medium leading-6 whitespace-nowrap"
                    >
                      Context
                      <p className="text-red-700">*</p>
                      <CustomPopover text="Context is filled with context of the dataset intent">
                        <QuestionMarkCircleIcon className="w-5 cursor-pointer text-blue-300" />
                      </CustomPopover>
                    </label>
                    <div className="mt-2">
                      <div>
                        <div className="border border-gray-300 rounded-md pr-8 p-2 focus-within:ring-2 focus-within:ring-blue-500 w-full flex flex-wrap items-center gap-2 relative">
                          {contextIntent.map((option, index) => (
                            <span
                              key={index}
                              className="bg-blue-100 text-blue-800 px-2 py-1 rounded-md flex items-center gap-1"
                            >
                              {option.label}
                              <button
                                type="button"
                                onClick={() =>
                                  setContextIntent(
                                    contextIntent.filter((_, i) => i !== index)
                                  )
                                }
                              >
                                <span className="text-xl text-red-500 hover:text-red-700">
                                  &times;
                                </span>
                              </button>
                            </span>
                          ))}
                          <input
                            type="text"
                            className="outline-none flex-grow placeholder:text-gray-400 placeholder:italic sm:text-sm sm:leading-6"
                            placeholder="Please input Context..."
                            onKeyDown={(e) =>
                              MultiSelectHandler(
                                e,
                                contextIntent,
                                setContextIntent
                              )
                            }
                          />
                          {contextIntent.length > 0 && (
                            <button
                              type="button"
                              onClick={() => setContextIntent([])}
                              className="absolute right-2 text-gray-400 hover:text-red-500"
                              tabIndex={-1}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="2"
                                stroke="currentColor"
                                className="w-5 h-5"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M6 18L18 6M6 6l12 12"
                                />
                              </svg>
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                    <label className="mt-2 text-gray-400 block text-sm font-medium leading-6">
                      Add new data by pressing " ; " button
                    </label>
                  </div>
                </div>

                <button
                  type="button"
                  onClick={() => generateAIValue("context", setContextIntent)}
                  disabled={
                    !(contextIntent.length > 0) || generating === "context"
                  }
                  className={`${contextIntent.length > 0 ? "bg-indigo-600 hover:bg-opacity-50" : "disabled bg-gray-300"} 
            md:ml-3 mt-2 md:mt-0 h-11 flex w-full md:w-auto justify-center whitespace-nowrap items-center 
            rounded-xl px-3 py-1.5 
            text-sm font-semibold leading-6 text-white shadow-sm 
            focus-visible:outline focus-visible:outline-2 
            focus-visible:outline-offset-2`}
                >
                  {generating === "context" ? (
                    <Spinner classAddition="w-[1.5rem] fill-white" />
                  ) : (
                    <SparklesIcon
                      className="text-white mr-3 flex-shrink-0 h-6 w-6"
                      aria-hidden="true"
                    />
                  )}
                  Generate with AI
                </button>
              </div>

              {/* Field Kolom */}
              <div className="flex flex-col md:flex-row justify-between items-center py-2 px-5 w-full">
                <div className="flex justify-between items-center w-full ">
                  <div className="w-full">
                    <label
                      htmlFor="phrase"
                      className="flex gap-1 text-sm font-medium leading-6 whitespace-nowrap"
                    >
                      Phrase
                      <p className="text-red-700">*</p>
                      <CustomPopover text="Phrase is filled with question phrase of the dataset intent">
                        <QuestionMarkCircleIcon className="w-5 cursor-pointer text-blue-300" />
                      </CustomPopover>
                    </label>
                    <div className="mt-2">
                      <div>
                        <div className="border border-gray-300 rounded-md pr-8 p-2 focus-within:ring-2 focus-within:ring-blue-500 w-full flex flex-wrap items-center gap-2 relative">
                          {phraseIntent.map((option, index) => (
                            <span
                              key={index}
                              className="bg-blue-100 text-blue-800 px-2 py-1 rounded-md flex items-center gap-1"
                            >
                              {option.label}
                              <button
                                type="button"
                                onClick={() =>
                                  setPhraseIntent(
                                    phraseIntent.filter((_, i) => i !== index)
                                  )
                                }
                              >
                                <span
                                  tabIndex={-1}
                                  className="text-red-500 hover:text-red-700"
                                >
                                  &times;
                                </span>
                              </button>
                            </span>
                          ))}
                          <input
                            type="text"
                            className="outline-none flex-grow placeholder:text-gray-400 placeholder:italic sm:text-sm sm:leading-6"
                            placeholder="Please input Phrase..."
                            onKeyDown={(e) =>
                              MultiSelectHandler(
                                e,
                                phraseIntent,
                                setPhraseIntent
                              )
                            }
                          />
                          {phraseIntent.length > 0 && (
                            <button
                              type="button"
                              onClick={() => setPhraseIntent([])}
                              className="absolute right-2 text-gray-400 hover:text-red-500"
                              tabIndex={-1}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="2"
                                stroke="currentColor"
                                className="w-5 h-5"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M6 18L18 6M6 6l12 12"
                                />
                              </svg>
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                    <label className="mt-2 text-gray-400 block text-sm font-medium leading-6">
                      Add new data by pressing " ; " button
                    </label>
                  </div>
                </div>

                <button
                  type="button"
                  onClick={() => generateAIValue("phrase", setPhraseIntent)}
                  disabled={
                    !(phraseIntent.length > 0) || generating === "phrase"
                  }
                  className={`${phraseIntent.length > 0 ? "bg-indigo-600 hover:bg-opacity-50" : "disabled bg-gray-300"} 
            md:ml-3 mt-2 md:mt-0 h-11 flex w-full md:w-auto justify-center whitespace-nowrap items-center 
            rounded-xl px-3 py-1.5 
            text-sm font-semibold leading-6 text-white shadow-sm 
            focus-visible:outline focus-visible:outline-2 
            focus-visible:outline-offset-2`}
                >
                  {generating === "phrase" ? (
                    <Spinner classAddition="w-[1.5rem] fill-white" />
                  ) : (
                    <SparklesIcon
                      className="text-white mr-3 flex-shrink-0 h-6 w-6"
                      aria-hidden="true"
                    />
                  )}
                  Generate with AI
                </button>
              </div>

              {/* Field Kolom */}
              <div className="flex flex-col md:flex-row justify-between items-center py-2 px-5 w-full">
                <div className="flex justify-between items-center w-full ">
                  <div className="w-full">
                    <label
                      htmlFor="response"
                      className="flex gap-1 text-sm font-medium leading-6 whitespace-nowrap"
                    >
                      Response
                      <p className="text-red-700">*</p>
                      <CustomPopover text="Response is filled with response of the question phrase of the dataset intent">
                        <QuestionMarkCircleIcon className="w-5 cursor-pointer text-blue-300" />
                      </CustomPopover>
                    </label>
                    <div className="mt-2">
                      <div>
                        <div className="border border-gray-300 rounded-md pr-8 p-2 focus-within:ring-2 focus-within:ring-blue-500 w-full flex flex-wrap items-center gap-2 relative">
                          {responseIntent.map((option, index) => (
                            <span
                              key={index}
                              className="bg-blue-100 text-blue-800 px-2 py-1 rounded-md flex items-center gap-1"
                            >
                              {option.label}
                              <button
                                type="button"
                                onClick={() =>
                                  setResponseIntent(
                                    responseIntent.filter((_, i) => i !== index)
                                  )
                                }
                              >
                                <span
                                  tabIndex={-1}
                                  className="text-red-500 hover:text-red-700"
                                >
                                  &times;
                                </span>
                              </button>
                            </span>
                          ))}
                          <input
                            type="text"
                            className="outline-none flex-grow placeholder:text-gray-400 placeholder:italic sm:text-sm sm:leading-6"
                            placeholder="Please input Response..."
                            onKeyDown={(e) =>
                              MultiSelectHandler(
                                e,
                                responseIntent,
                                setResponseIntent
                              )
                            }
                          />
                          {responseIntent.length > 0 && (
                            <button
                              type="button"
                              onClick={() => setResponseIntent([])}
                              className="absolute right-2 text-gray-400 hover:text-red-500"
                              tabIndex={-1}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="2"
                                stroke="currentColor"
                                className="w-5 h-5"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M6 18L18 6M6 6l12 12"
                                />
                              </svg>
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                    <label className="mt-2 text-gray-400 block text-sm font-medium leading-6">
                      Add new data by pressing " ; " button
                    </label>
                  </div>
                </div>

                <button
                  type="button"
                  onClick={() => generateAIValue("response", setResponseIntent)}
                  disabled={
                    !responseIntent.length > 0 || generating === "response"
                  }
                  className={`${responseIntent.length > 0 ? "bg-indigo-600 hover:bg-opacity-50" : "disabled bg-gray-300"} 
            md:ml-3 mt-2 md:mt-0 h-11 flex w-full md:w-auto justify-center whitespace-nowrap items-center 
            rounded-xl px-3 py-1.5 
            text-sm font-semibold leading-6 text-white shadow-sm 
            focus-visible:outline focus-visible:outline-2 
            focus-visible:outline-offset-2`}
                >
                  {generating === "response" ? (
                    <Spinner classAddition="w-[1.5rem] fill-white" />
                  ) : (
                    <SparklesIcon
                      className="text-white mr-3 flex-shrink-0 h-6 w-6"
                      aria-hidden="true"
                    />
                  )}
                  Generate with AI
                </button>
              </div>
            </div>
          ) : (
            <div></div>
          )}
        </div>
      </form>
      <LoadingModal open={isLoading} />
    </div>
  );
}

export default CreateIntents;
